"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpProfilePicture = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var DpProfilePicture_styled_1 = require("./DpProfilePicture.styled");
var a_svg_1 = __importDefault(require("./assets/a.svg"));
var b_svg_1 = __importDefault(require("./assets/b.svg"));
var c_svg_1 = __importDefault(require("./assets/c.svg"));
var d_svg_1 = __importDefault(require("./assets/d.svg"));
var teacher_default_picture_png_1 = __importDefault(require("./assets/teacher-default-picture.png"));
var random_1 = __importDefault(require("lodash/random"));
var api_1 = require("../../../api");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var image_1 = __importDefault(require("next/image"));
var DpProfilePicture = function (_a) {
    var user = _a.user, clickHandler = _a.clickHandler, _b = _a.showName, showName = _b === void 0 ? true : _b, _c = _a.variant, variant = _c === void 0 ? api_1.ProfilePictureVariant.Initials : _c, _d = _a.bigSize, bigSize = _d === void 0 ? false : _d;
    var pictures = [a_svg_1.default, b_svg_1.default, c_svg_1.default, d_svg_1.default];
    // ------------------------------- Actions
    var viewProfile = function (selectedUser) { return function (e) {
        if (clickHandler) {
            clickHandler(selectedUser);
        }
    }; };
    // ------------------------------- Render
    var defaultPicture = user.isStudent
        ? pictures[(0, random_1.default)(pictures.length - 1)]
        : teacher_default_picture_png_1.default;
    var getProfileIcon = function () {
        var _a, _b;
        switch (variant) {
            case api_1.ProfilePictureVariant.Initials:
                return ((0, jsx_runtime_1.jsxs)("div", { className: "profile-initials ".concat(bigSize ? 'bigSize' : ''), onClick: viewProfile(user), role: "button", children: [(0, jsx_runtime_1.jsx)("span", { children: (_a = user.firstName) === null || _a === void 0 ? void 0 : _a.charAt(0).toUpperCase() }), (0, jsx_runtime_1.jsx)("span", { className: "lastNameInitial", children: (_b = user.lastName) === null || _b === void 0 ? void 0 : _b.charAt(0).toUpperCase() })] }));
            case api_1.ProfilePictureVariant.Impersonation:
                return ((0, jsx_runtime_1.jsx)("div", { className: "profile-impersonation", children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "impersonate", size: 16 }) }));
            case api_1.ProfilePictureVariant.InitialsImage:
                return ((0, jsx_runtime_1.jsxs)("div", { className: "profile-initials ".concat(bigSize ? 'bigSize' : ''), children: [user.firstName && (0, jsx_runtime_1.jsx)("span", { children: user.firstName.charAt(0).toUpperCase() }), user.lastName && ((0, jsx_runtime_1.jsx)("span", { className: "lastNameInitial", children: user.lastName.charAt(0).toUpperCase() }))] }));
            default:
                return ((0, jsx_runtime_1.jsx)(image_1.default, { className: "rounded-circle", src: defaultPicture, alt: user.fullName, onClick: viewProfile(user), width: 80, height: 80 }));
        }
    };
    return ((0, jsx_runtime_1.jsxs)(DpProfilePicture_styled_1.StyledProfilePicture, { student: user.isStudent ? 1 : 0, className: "profile-picture", children: [showName && (0, jsx_runtime_1.jsx)("span", { className: "fullName", children: user.fullName }), getProfileIcon()] }));
};
exports.DpProfilePicture = DpProfilePicture;
exports.default = exports.DpProfilePicture;
